<template>
  <model-crud
    :model="model"
    :fields="fields"
    :pre-save="preSave"
  />
</template>

<script>
import ModelCrud from '@/components/ModelCrud'
import CompanyDelegation from '@/models/CompanyDelegation'

export default {
  data () {
    return {
      model: CompanyDelegation,
      fields: {
        dateFrom: {
          label: this.$t('headers.dateFrom'),
          type: 'date',
          fill: true,
          preProcess: (value) => value && value.substr(0, value.lastIndexOf(':')),
          postProcess: (value) => value && (value + ':00.000Z')
        },
        duration: {
          label: this.$t('headers.delegationDuration'),
          hint: this.$t('headers.delegationDurationHint'),
          fill: true
        },
        enabled: {
          label: this.$t('headers.enabled'),
          type: 'bool',
          default: true,
          fill: true
        }
      }
    }
  },
  methods: {
    preSave (item, fields) {
      item.company = this.$store.auth.user.company
    }
  },
  components: {
    ModelCrud
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// CompanyDelegations.vue?789c705e